import {
  BarChart2,
  Briefcase,
  ClipboardCheck,
  Download,
  Filter,
  TrendingUp,
  Users,
} from 'lucide-react';
import type { IReportingTabDef, ReportingTabId } from '../interfaces';

export const REPORTING_BASE_PATH = '/reporting';
export const DEFAULT_REPORTING_TAB: ReportingTabId = 'overview';

export const REPORTING_TABS: IReportingTabDef[] = [
  { id: 'overview', label: 'Overview', icon: BarChart2, path: `${REPORTING_BASE_PATH}/overview` },
  { id: 'recruitment_funnel', label: 'Recruitment Funnel', icon: Filter, path: `${REPORTING_BASE_PATH}/recruitment_funnel` },
  { id: 'job_performance', label: 'Job Performance', icon: Briefcase, path: `${REPORTING_BASE_PATH}/job_performance` },
  { id: 'candidate_insights', label: 'Candidate Insights', icon: Users, path: `${REPORTING_BASE_PATH}/candidate_insights` },
  { id: 'assessment_analytics', label: 'Assessment Analytics', icon: ClipboardCheck, path: `${REPORTING_BASE_PATH}/assessment_analytics` },
  { id: 'hiring_outcomes', label: 'Hiring Outcomes', icon: TrendingUp, path: `${REPORTING_BASE_PATH}/hiring_outcomes` },
  { id: 'exports', label: 'Exports', icon: Download, path: `${REPORTING_BASE_PATH}/exports` },
];

export const REPORTING_TAB_IDS: ReportingTabId[] = REPORTING_TABS.map((tab) => tab.id);

export const REPORTING_DEPARTMENTS: string[] = [
  'Engineering',
  'Product',
  'Sales',
  'Marketing',
  'HR',
];

export const REPORTING_JOB_TITLES: string[] = [];
